module.exports = __webpack_public_path__ + "img/108038.40404eaa.png";